import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'HomeView',
    component: () => import('@/components/pages/home/HomeView.vue'),
    meta: {
      layout: 'list'
    }
  },
  {
    path: '/qr',
    name: 'QrScanView',
    component: () => import('@/components/pages/qr/QrScanView.vue'),
    meta: {
      noHeader: true,
      layout: 'list'
    },
  },
  {
    path: '/qr/mint',
    name: 'QrMintView',
    component: () => import('@/components/pages/qr/QrMintView.vue'),
    meta: {
      noHeader: true,
      layout: 'blank'
    }
  },
  {
    path: '/rsvp/:cltnId',
    name: 'RsvpView',
    component: () => import('@/components/pages/rsvp/RsvpView.vue'),
    meta: {
      noHeader: true,
      layout: 'blank'
    }
  },
  {
    path: '/seat/:cltnId',
    name: 'SeatSelectView',
    component: () => import('@/components/pages/seat/SeatSelectView.vue'),
    meta: {
      noHeader: true,
      layout: 'blank'
    }
  },
  {
    path: '/nal/:link',
    name: 'NftAccessLinkView',
    component: () => import('@/components/pages/home/NftAccessLinkView.vue'),
    meta: {
      layout: 'blank',
      unAuth: true,
    }
  },
  {
    path: '/block/email/:id',
    name: 'BlockEmailView',
    component: () => import('@/components/pages/BlockEmailView.vue'),
    meta: {
      layout: 'blank',
      unAuth: true,
    }
  },
];

export default routes
